import { useCart } from '../../cart-provider';

export function useLogout() {
  const cartContext = useCart();

  const logout = async (onSuccess?: () => void, onError?: (error: string) => void) => {
    try {
      const loggedOut = await cartContext.logout();

      if (loggedOut) {
        if (onSuccess) {
          onSuccess();
        }
        return true;
      } else {
        if (onError) {
          onError('Logout failed');
        }
        return false;
      }
    } catch (error) {
      if (onError) {
        onError(`Something went wrong: ${error}`);
      }
      console.error(error);
      return false;
    }
  };

  return { logout };
}

export default useLogout;
